var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Take the J.E.D.I. pledge")]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "mt-3 font-sans-book text-lg",
          staticStyle: { "line-height": "1.75rem" },
        },
        [
          _vm._v(
            "\n    Reimagine is committed to uplifting diverse voices and actively advancing Justice, Equity, Diversity, and Inclusion (J.E.D.I.) throughout the world. To help us improve and to make sure we are fostering a safe, inclusive community, we appreciate you answering the following questions and taking Reimagine’s J.E.D.I. pledge.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("div", [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "group__checkbox mt-2" }, [
          _c(
            "div",
            { staticClass: "flex flex-wrap select-box" },
            [
              _vm._l(_vm.options.ethnicities, function (option) {
                return [
                  _c(
                    "label",
                    {
                      key: option.id,
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.ethnicities,
                            expression: "form.ethnicities",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: option.id,
                          checked: Array.isArray(_vm.form.ethnicities)
                            ? _vm._i(_vm.form.ethnicities, option.id) > -1
                            : _vm.form.ethnicities,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.ethnicities,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = option.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "ethnicities",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "ethnicities",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "ethnicities", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 check" }),
                      _vm._v(" " + _vm._s(option.name) + "\n          "),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("div", [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "group__checkbox mt-2" }, [
          _c(
            "div",
            { staticClass: "flex flex-wrap select-box" },
            [
              _vm._l(_vm.options.pronouns, function (option) {
                return [
                  _c(
                    "label",
                    {
                      key: option.id,
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.pronouns,
                            expression: "form.pronouns",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: option.id,
                          checked: Array.isArray(_vm.form.pronouns)
                            ? _vm._i(_vm.form.pronouns, option.id) > -1
                            : _vm.form.pronouns,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.pronouns,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = option.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "pronouns",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "pronouns",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "pronouns", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 check" }),
                      _vm._v(" " + _vm._s(option.name) + "\n          "),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("div", [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "group__checkbox mt-2" }, [
          _c(
            "div",
            { staticClass: "flex flex-wrap select-box" },
            [
              _vm._l(_vm.options.genders, function (option) {
                return [
                  _c(
                    "label",
                    {
                      key: option.id,
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.genders,
                            expression: "form.genders",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: option.id,
                          checked: Array.isArray(_vm.form.genders)
                            ? _vm._i(_vm.form.genders, option.id) > -1
                            : _vm.form.genders,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.genders,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = option.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "genders",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "genders",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "genders", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 check" }),
                      _vm._v(" " + _vm._s(option.name) + "\n          "),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("div", [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "group__checkbox mt-2" }, [
          _c(
            "div",
            { staticClass: "flex flex-wrap select-box" },
            [
              _vm._l(_vm.options.sexualities, function (option) {
                return [
                  _c(
                    "label",
                    {
                      key: option.id,
                      staticClass:
                        "w-full text-base font-normal md:w-1/2 md:pr-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.sexualities,
                            expression: "form.sexualities",
                          },
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: option.id,
                          checked: Array.isArray(_vm.form.sexualities)
                            ? _vm._i(_vm.form.sexualities, option.id) > -1
                            : _vm.form.sexualities,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.form.sexualities,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = option.id,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "sexualities",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "sexualities",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "sexualities", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "inline-block mr-2 check" }),
                      _vm._v(" " + _vm._s(option.name) + "\n          "),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("hr", { staticClass: "w-px bg-n-gray border border-n-gray w-full" }),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _c("label", [
        _vm._v("\n    Sign the Reimagine J.E.D.I. Community Pledge\n  "),
      ]),
      _vm._v(" "),
      _c("JediCommunityPledge"),
      _vm._v(" "),
      _c("div", { staticClass: "select-box mt-4" }, [
        _c("label", { staticClass: "w-full text-base font-normal" }, [
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.community_pledge,
                expression: "form.community_pledge",
              },
            ],
            attrs: { name: "community_pledge", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.form.community_pledge)
                ? _vm._i(_vm.form.community_pledge, null) > -1
                : _vm.form.community_pledge,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.form.community_pledge,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.form, "community_pledge", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        "community_pledge",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, "community_pledge", $$c)
                }
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "inline-block mr-2 check" }),
          _vm._v(" "),
          _c("span", { staticClass: "font-normal font-sans-book" }, [
            _vm._v(
              "\n        I agree to the J.E.D.I. Community Pledge\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("community_pledge"),
              expression: "errors.has('community_pledge')",
            },
          ],
          staticClass: "block error-message",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                (_vm.errors.first("community_pledge") || "").replace("_", " ")
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("hr", { staticClass: "w-px bg-n-gray border border-n-gray w-full" }),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._v(
            "\n    Required actions to cultivate JEDI (Justice, Equity Diversity, and Inclusion):\n    I agree to attend live or watch a recording of The Art of Creating Inclusive Spaces,\n    a 90-minute training developed in partnership with our collaborators\n    at "
          ),
          _c(
            "NewTabA11y",
            { attrs: { href: "https://www.holisticunderground.org/" } },
            [_vm._v("Holistic Underground")]
          ),
          _vm._v(
            ",\n    a non-profit that supports projects which empower change makers, leaders and organizations in social and environmental impact.\n    The training and workshop materials can be found "
          ),
          _c(
            "NewTabA11y",
            {
              attrs: {
                href: "https://letsreimagine.org/creating-inclusive-spaces",
              },
            },
            [_vm._v("here")]
          ),
          _vm._v(
            ".\n    Or, I agree to attend another formal training program to increase my skill and capacity for creating space through an equity and inclusion lens.\n  "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "flex flex-wrap select-box" }, [
          _c(
            "label",
            {
              staticClass:
                "w-full text-base font-normal md:w-1/2 md:pr-3 pb-2 md:pb-0",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.jedi_training,
                    expression: "form.jedi_training",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  name: "jedi_training",
                  type: "radio",
                  value: "will_watch",
                },
                domProps: {
                  checked: _vm._q(_vm.form.jedi_training, "will_watch"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form, "jedi_training", "will_watch")
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "inline-block mr-2 radio" }),
              _vm._v(" I agree to watch the training\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "w-full text-base font-normal md:w-1/2 md:pr-3" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.jedi_training,
                    expression: "form.jedi_training",
                  },
                ],
                attrs: {
                  name: "jedi_training",
                  type: "radio",
                  value: "already_trained",
                },
                domProps: {
                  checked: _vm._q(_vm.form.jedi_training, "already_trained"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.form,
                      "jedi_training",
                      "already_trained"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "inline-block mr-2 radio" }),
              _vm._v(" I have already attended a similiar training\n      "),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("jedi_training"),
                expression: "errors.has('jedi_training')",
              },
            ],
            staticClass: "block error-message",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  (_vm.errors.first("jedi_training") || "").replace("_", " ")
                ) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.form.jedi_training === "already_trained"
          ? _c("div", { staticClass: "mt-2" }, [
              _c("label", [
                _vm._v(
                  "\n        What is the name of the training you have attended?\n      "
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.jedi_training_received,
                    expression: "form.jedi_training_received",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:60",
                    expression: "'required|max:60'",
                  },
                ],
                attrs: {
                  id: "jedi_training_received",
                  name: "jedi_training_received",
                  type: "text",
                },
                domProps: { value: _vm.form.jedi_training_received },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.form,
                      "jedi_training_received",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("jedi_training_received"),
                      expression: "errors.has('jedi_training_received')",
                    },
                  ],
                  staticClass: "block error-message",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        (
                          _vm.errors.first("jedi_training_received") || ""
                        ).replaceAll("_", " ")
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("hr", { staticClass: "w-px bg-n-gray border border-n-gray w-full" }),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
      _vm._v(" "),
      _c("div", { staticClass: "flex justify-center" }, [
        _c("button", { staticClass: "button", on: { click: _vm.finish } }, [
          _vm._v("finish"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "spacer" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      {
        staticClass: "mt-3 font-sans-book text-lg",
        staticStyle: { "line-height": "1.75rem" },
      },
      [
        _vm._v(
          "\n    If you self-identify as an individual from an underrepresented community (person of color, person with disabilities, LGBTQ+, etc.)\n    or you plan to center the experiences of underrepresented communities in your event,\n    you may be eligible for in-kind Facebook ads to help with promotion: $100 each to 25 Reimagine event hosts.\n    Simply contact our "
        ),
        _c("a", { attrs: { href: "mailto:margaret@letsreimagine.org" } }, [
          _vm._v("Marketing Manager"),
        ]),
        _vm._v(" if you have questions or wish to nominate someone.\n  "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n      What ethnicity do you identify with? (optional)\n      "),
      _c("span", { staticClass: "block text-sm font-sans-book" }, [
        _vm._v("\n        Choose as many as you like\n      "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n      What pronouns do you identify with? (optional)\n      "),
      _c("span", { staticClass: "block text-sm font-sans-book" }, [
        _vm._v("\n        Choose as many as you like\n      "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v(
        "\n      What gender identity do you identify with? (optional)\n      "
      ),
      _c("span", { staticClass: "block text-sm font-sans-book" }, [
        _vm._v("\n        Choose as many as you like\n      "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("\n      What is your sexual orientation? (optional)\n      "),
      _c("span", { staticClass: "block text-sm font-sans-book" }, [
        _vm._v("\n        Choose as many as you like\n      "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "mb-5" }, [
      _vm._v("Shared commitment "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }